/* tslint:disable:max-line-length */
import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const de: DeepPartial<Messages> = {
  custom: {
    clearSearchInput: 'löschen',
    facetsHeader: 'Filter'
  },
  close: { buttonText: '' },
  facets: {
    defaultRange: { fromHTML: 'mehr als {min}' },
    titles: {
      price_facet: 'Preis',
      sizes_facet: 'Talla',
      color_facet: 'Farbe'
    },
    toggle: {
      default: {
        openHTML: '{numFound} Ergebnisse filtern',
        closeHTML: '{numFound} Ergebnisse anzeigen'
      }
    }
  },
  history: {
    disable: 'on',
    enable: 'off'
  },
  search: {
    inputPlaceholderAlternativesHTML: ['']
  },
  noResults: {
    messageHTML: `<span class="ebx-no-results__mgoccessage-apologies">Wir haben keine Ergebnisse gefunden für </span>
         <span class="ebx-no-results__message-query">{query}'</span><span class="ebx-no-results__message-try-again">
        Dies sind die meistaufgerufene</span>`
  },
  nextQueries: {
    titleHTML: 'Das könnte Sie interessieren',
    nextQuery: {
      titleHTML: 'Andere User haben nach <span class="ebx-next-query__title-query">{query}</span> gesucht'
    }
  },
  partialResult: {
    messageHTML: `<span class="ebx-partials__message-apologies">Wir haben kein Ergebnis finden können für </span><span class="ebx-partials__message-query">'{query}'</span><span class="ebx-partials__message-try-again"> Vielleicht interessieren Sie die folgenden Produkte</span>`,
    titleHTML: '<span class="ebx-partial-result__title-num-found">{numFound}</span> Ergebnisse für <span class="ebx-partial-result__title-term">{term}</span>'

  },
  sort: {
    titleHTML: 'Sortieren nach {selectedItem}',
    sortTitles: {
      default: 'Relevanz',
      priceAsc: 'Preis aufst.',
      priceDesc: 'Preis abst.',
      alphabeat: 'Alphabetisch'
    }
  }
};
